<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import lightGallery from "lightgallery";
import lgFullscreen from "lightgallery/plugins/fullscreen";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import { FreeMode, Thumbs, Pagination } from "swiper/modules";

const props = defineProps({
  sliders: {
    type: Array,
  },
});

function onInit() {}

function onBeforeSlide() {
  console.log("calling before slide");
}

const thumbsSwiper = ref(null);

const setThumbsSwiper = (swiper) => {
  thumbsSwiper.value = swiper;
};

onMounted(() => {
  let lgSwiper = document.querySelector(".lg-swipper");

  lightGallery(lgSwiper, {
    speed: 500,
    mode: "lg-fade",
    plugins: [lgThumbnail, lgFullscreen],
    zoom: true,
    mobileSettings: {
      controls: true,
      showCloseIcon: true,
      download: false,
      toggleThumb: false,
    },
    allowMediaOverlap: true,
    toggleThumb: true,
  });

  const images = document.querySelectorAll(".swiper-slide img");
  const sliderContainer = document.querySelector(".swiper");

  images.forEach((image, index) => {
    if (index === 0) {
      setOptimalObjectFit(image, sliderContainer);
    } else {
      image.style.objectFit = images[0].style.objectFit;
    }
  });
});

function setOptimalObjectFit(image, container) {
  const imageRatio = image.naturalWidth / image.naturalHeight;
  const containerRatio = container.offsetWidth / container.offsetHeight;

  if (imageRatio > containerRatio + 0.4) {
    image.style.objectFit = "cover";
  } else {
    image.style.objectFit = "contain";
  }
}

const modules = ref([FreeMode, Thumbs, Pagination]);
</script>

<template>
  <div class="w-70 xs:w-90 sm:w-120 h-full px-4 pb-6 pt-5">
    <swiper
      :style="{
        '--swiper-navigation-color': '#fff',
        '--swiper-pagination-color': '#fff',
      }"
      :spaceBetween="10"
      :navigation="false"
      :pagination="true"
      :breakpoints="{
        0: {
          pagination: {
            clickable: true,
          },
        },
        640: { pagination: false },
      }"
      :thumbs="{ swiper: thumbsSwiper }"
      :modules="modules"
      class="thumbsSwiper2 w-full h-65 xs:h-85 sm:h-112"
      wrapperClass="lg-swipper"
    >
      <swiper-slide
        v-for="(slide, index) in sliders"
        :key="index"
        :data-src="slide"
      >
        <div class="flex items-center rounded-lg">
          <img
            :src="slide"
            class="cursor-zoom-in !my-auto block aspect-square rounded-lg w-full h-auto"
          />
        </div>
      </swiper-slide>
    </swiper>
    <swiper
      @swiper="setThumbsSwiper"
      :spaceBetween="12"
      :slidesPerView="5"
      :freeMode="true"
      :watchSlidesProgress="true"
      :modules="modules"
      class="mt-3 thumbsSwiper"
      v-if="sliders.length > 1"
    >
      <swiper-slide v-for="(slide, ind) in sliders"
        ><img :src="slide" class="rounded-lg w-full h-16 !aspect-video"
      /></swiper-slide>
    </swiper>
  </div>
</template>

<style>
@import "lightgallery/css/lightgallery.css";
@import "lightgallery/css/lg-thumbnail.css";
@import "lightgallery/css/lg-zoom.css";

@media (max-width: 640px) {
  .thumbsSwiper {
    display: none !important;
  }
}

/* */
.thumbsSwiper2 .swiper-pagination {
  right: auto;
  bottom: -5px !important;
}
.thumbsSwiper2 .swiper-pagination-bullet {
  width: 30px !important; /* Ширина линии */
  max-width: 50px !important;
  min-width: 20px !important;
  height: 2px !important; /* Высота линии */
  background: #a3a7b8; /* Убираем фон по умолчанию */

  /* border: 2px solid #ccc; Создаем пунктирную линию */
  border-radius: 10% / 50%; /* Убираем скругление
  margin: 0 10px; /* Отступы между линиями */
  opacity: 1; /* Делаем все линии видимыми */
  transform: scale(1) !important;
}

.thumbsSwiper2 .swiper-pagination-bullet-active {
  width: 30px; /* Ширина линии */
  height: 2px; /* Высота линии */
  border-radius: 10% / 50%;
  /* border-radius: 5.5; Убираем скругление */
  background: #3a405a !important; /* Цвет активной линии */
  transform: scale(1);
}

/* */

.lg-outer .lg-thumb-item {
  border-radius: 4px !important;
  border: 2px solid #fff !important;
  -webkit-transition: border-color 0.25s ease;
  -o-transition: border-color 0.25s ease;
  transition: border-color 0.25s ease;
}
.lg-outer .lg-thumb-item.active,
.lg-outer .lg-thumb-item:hover {
  border-color: rgb(251 121 39) !important;
}

.lg-outer .lg-item.lg-complete.lg-zoomable .lg-image,
.lg-outer .lg-item.lg-complete.lg-zoomable .lg-dummy-img {
  width: 710px !important;
}

@media (min-width: 641px) {
  .lg-outer .lg-object {
    display: inline-block;
    vertical-align: middle;
    max-width: 550px !important;
    max-height: 100%;
    width: auto;
    height: auto;
    position: relative;
  }
}

@media (max-width: 640px) {
  .lg-outer .lg-object {
    display: inline-block;
    vertical-align: middle;
    max-width: 100% !important;
    max-height: 100%;
    width: auto;
    height: auto;
    position: relative;
  }
}

.thumbsSwiper {
  height: 20%;
  box-sizing: border-box;
  padding: 10px 0;
}

.thumbsSwiper .swiper-slide {
  width: 80px !important;
  height: 64px !important;
  object-fit: cover !important;
  cursor: pointer;
  /* opacity: 0.4; */
}

.thumbsSwiper .swiper-slide-thumb-active {
  position: relative;
}

.thumbsSwiper .swiper-slide-thumb-active::before {
  /* opacity: 1; */
  position: absolute;
  content: "";
  border-bottom: 3px solid #3a405a;
  bottom: 0;
  width: 100%;
  height: 2px;
  left: 0;
  bottom: -6px;
  border-radius: 16px;
  /* border-radius: 1px; */
}

/* .swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
} */

/* @media (min-width: 641px) {
  .swiper-slide .img-responsive {
    display: block;
    width: 440px;
    height: 380px;
    object-fit: contain;
  }
}

@media (max-width: 640px) and (min-width: 426px) {
  .swiper-slide .img-responsive {
    display: block;
    height: 310px;
    width: 340px;
    object-fit: contain;
  }
}

@media (max-width: 425px) {
  .swiper-slide .img-responsive {
    height: 300px;
    width: 300px;
  } */
/* } */
</style>
